import React from "react";
import dayjs from "dayjs";
import Link from "next/link";
import SupportSection from "@/components/SupportSection/SupportSection";

interface AuthMobileLayoutProps {
  children: React.ReactNode;
  className: string;
}

const AuthMobileLayout: React.FC<AuthMobileLayoutProps> = ({
  children,
  className,
}) => {
  const currentYear = dayjs().year();
  return (
    <div
      className={`flex flex-col bg-[#FFFFFF] ${className} `}
      data-testid="AuthMobileLayout"
    >
      <div className="flex flex-col self-stretch   ">
        <div className="self-stretch mb-[19px]">
          <div
            className="backgroundSection flex flex-col self-stretch  h-[405px] pb-[165px] object-fill pt-11"
          >
            <span className="text-[#2D2D2D] text-[18px] leading-[120%] text-center mb-2">
              {"Welcome to"}
            </span>
            <span className="text-[#1F1F1F] text-[32px] font-bold text-center mb-[28px]">
              GTE<span className="text-[#0B559F]">Connects </span>
            </span>
            <span className="text-[#767676] text-[14px] leading-5 mx-7">
              {
                "Join 25K+ agents using GTEConnects for their hotel booking needs. One platform to help you search and book over 2.3M properties worldwide."
              }
            </span>
          </div>
          {children}
        </div>

        <SupportSection className="flex items-center justify-between self-stretch mb-[83px] px-4" />
        <div className="flex gap-3 items-center justify-center mb-[14px] ">
          <Link href="/privacy" passHref className="text-xs  text-[#767676]">
            Privacy Cookies
          </Link>
          <span className="text-[#767676] text-[12px]">•</span>
          <Link
            href="/terms-and-conditions"
            passHref
            className="text-xs  text-[#767676]"
          >
            Terms & Conditions
          </Link>
        </div>
        <div className="text-[#767676] text-[12px] text-center mb-6">
          Copyright (c) {currentYear} GTEConnects. All rights Reserved
        </div>
      </div>
    </div>
  );
};

export default AuthMobileLayout;
